import React, { useState } from "react";
import ProcessDetail from "../../components/ProcessDetail/ProcessDetail";
import {
  ProcessDetailObj1,
  ProcessDetailObj2,
  ProcessDetailObj3,
  ProcessDetailObj4,
} from "../../components/ProcessDetail/ProcessDetailData";
import "./Process.css";
import { Routes, Route, NavLink } from "react-router-dom";
import { motion } from "framer-motion";

const processVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: { duration: 1 },
  },
};

const Process = () => {
  return (
    <div className="howWeWork scale-up-top" id="process">
      <nav className="process__sidebar">
        <ul>
          <li className="navList__item">
            <NavLink
              isActive
              className={({ isActive }) =>
                isActive
                  ? "navList__item__link_active fade-in-left "
                  : "navList__item__link_inactive"
              }
              to="/"
            >
              <h3 className="phaseHeading">Phase 1</h3>
              <p className="phaseDesc">Agenda</p>
            </NavLink>
          </li>
          <li className="navList__item">
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "navList__item__link_active fade-in-left"
                  : "navList__item__link_inactive"
              }
              to="content"
            >
              <h3 className="phaseHeading">Phase 2</h3>
              <p className="phaseDesc">Content</p>
            </NavLink>
          </li>

          <li className="navList__item">
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "navList__item__link_active fade-in-left"
                  : "navList__item__link_inactive"
              }
              to="discussions"
            >
              <h3 className="phaseHeading"> Phase 3</h3>
              <p className="phaseDesc">Discussions</p>
            </NavLink>
          </li>

          <li className="navList__item">
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "navList__item__link_active fade-in-left"
                  : "navList__item__link_inactive"
              }
              to="final"
            >
              <h3 className="phaseHeading">Phase 4</h3>
              <p className="phaseDesc">Finale</p>
            </NavLink>
          </li>
        </ul>
      </nav>

      <motion.div
        variants={processVariants}
        initial="hidden"
        animate="visible"
        className="process section__padding"
      >
        <Routes>
          <Route path="/" element={<ProcessDetail {...ProcessDetailObj1} />} />
          <Route
            path="content"
            element={<ProcessDetail {...ProcessDetailObj2} />}
          />
          <Route
            path="discussions"
            element={<ProcessDetail {...ProcessDetailObj3} />}
          />
          <Route
            path="final"
            element={<ProcessDetail {...ProcessDetailObj4} />}
          />
        </Routes>
      </motion.div>
    </div>
  );
};

export default Process;
